import { sugerirPattern } from './rota_matcher.js'
import { TOUR_ROTAS_SEM_TOUR_KEY } from './storage_keys.js'

export const VALIDADE_ROTA_SEM_TOUR_MS = 30 * 60 * 1000

function lerEntradas() {
  try {
    const entradas = JSON.parse(sessionStorage.getItem(TOUR_ROTAS_SEM_TOUR_KEY))
    return entradas && typeof entradas === 'object' && !Array.isArray(entradas) ? entradas : {}
  } catch (e) {
    console.warn('Falha ao ler o cache de rotas sem tour:', e)
    return {}
  }
}

function entradaVigente(registradaEm, agora) {
  return typeof registradaEm === 'number' && agora - registradaEm < VALIDADE_ROTA_SEM_TOUR_MS
}

export function rotaSemTour(rota) {
  const chave = sugerirPattern(rota)
  if (chave === '') return false
  return entradaVigente(lerEntradas()[chave], Date.now())
}

export function registrarRotaSemTour(rota) {
  const chave = sugerirPattern(rota)
  if (chave === '') return

  const agora = Date.now()
  const vigentes = Object.fromEntries(
    Object.entries(lerEntradas()).filter(([, registradaEm]) => entradaVigente(registradaEm, agora))
  )

  try {
    sessionStorage.setItem(TOUR_ROTAS_SEM_TOUR_KEY, JSON.stringify({ ...vigentes, [chave]: agora }))
  } catch (e) {
    console.warn('Falha ao gravar o cache de rotas sem tour:', e)
  }
}

export function limparRotasSemTour() {
  try {
    sessionStorage.removeItem(TOUR_ROTAS_SEM_TOUR_KEY)
  } catch (e) {
    console.warn('Falha ao limpar o cache de rotas sem tour:', e)
  }
}
